import React, { Component } from "react";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
} from "react-router-dom";
import LoginCode from "./Pages/LoginCode";
import Welcome from "./Pages/Welcome";
import BirthdateVerification from "./Pages/BirthdateVerification";

import InformationReview from "./Pages/InformationReview";
import Signature from "./Pages/Signature";
import MainWrapperGI from "./Pages/General-info/MainWrapperGI";
import MainWrapperFi from "./Pages/Financial-info/MainWrapperFi";
import MainWrapperHousehold from "./Pages/Household/MainWrapperHousehold";
import MainWrapperDocuments from "./Pages/Documents/MainWrapperDocuments";

import Feedback from "./Pages/Feedback";
import Logout from "./Pages/Logout";
import Thankyou from "./Pages/Thankyou";
import NotFound from "./Pages/NotFound";

import { langData, langDataCustom, apiUrl, logoUrl } from "./Helpers/urls";

import { ReactComponent as ArrowForwardIosIcon } from "./styles/imgs/arrow-icon-right.svg";
import { ReactComponent as ArrowBackIosIcon } from "./styles/imgs/arrow-icon-left.svg";
import { ReactComponent as Loader } from "./styles/imgs/loader.svg";

import { encode, decode } from "he";

import "./App.scss";

// import LangsData from './json/LangsData';

class App extends Component {
  state = {
    loading: false,
    loadingFail: false,
    loginFail: false,
    innerLoader: false,
    confirmNewDocuments: false,
    benefitRecordId: "",
    languages: {
      en: {
        errorMsg: "Something went wrong. \n Please try again.",
        loginFailMsg: "Error: Access Denied",
        newCodeMsg: "",
        mm: "",
        dd: "",
        yy: "",
        months: {
          jan: "",
          feb: "",
          mar: "",
          apr: "",
          may: "",
          jun: "",
          jul: "",
          aug: "",
          sep: "",
          oct: "",
          nov: "",
          dec: "",
        },
        loginPage: {
          mainTitle: "",
          companyName: "",
          intoText: "",
          formTitle: "",
          formTitleCode: "",
          codePlaceholder: "",
          deleteText: "",
          continueText: "",
          or: "",
        },
        Welcome: { helloText: "", intoText: "" },
        BirthdatePage: { mainTitle: "", formTitle: "", continueText: "" },
        InformationReviewPage: {
          mainTitle: "",
          intoText: "",
          formTitle: "",
          firstNameLabel: "",
          lastNameLabel: "",
          genderLabel: "",
          inputPlaceholder: "",
          maleText: "",
          femaleText: "",
          ssnLabel: "",
          phoneLabel: "",
          emailLabel: "",
          birthdateLabel: "",
          addressLabelLine1: "",
          addressLabelLine2: "",
          cityLabel: "",
          stateLabel: "",
          zipLabel: "",
          nextBtn: "",
          prevBtn: "",
          endSession: "",
        },
        GeneralInfo: {
          Step1: {
            mainTitle: "",
            yesText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step2: {
            mainTitle: "",
            yesText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step3: {
            mainTitle: "",
            yesText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step4: {
            mainTitle: "",
            yesText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step5: {
            mainTitle: "",
            yesText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step6: {
            mainTitle: "",
            intoText: "",
            spouseText: "",
            childrenText: "",
            otherDependentsText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step7: {
            mainTitle: "",
            aditionalInfo: "",
            aditionalInfoBottom: "",
            currencyText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step8: {
            leadText: "",
            mainTitle: "",
            intoText: "",
            motivationText: "",
            callToActionText: "",
            aditionalInfo: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
        },
        FinancialInfo: {
          Step1: {
            mainTitle: "",
            yesText: "",
            employerNameText: "",
            monthyIncomeText: "",
            monthyIncomePlaceholder: "",
            employerNamePlacehoder: "",
            addText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step2: {
            mainTitle: "",
            yesText: "",
            noText: "",
            addText: "",
            monthyAmountText: "",
            monthyAmountPlaceholder: "",
            unemployment: "",
            socialSecurity: "",
            pensions: "",
            retirementAccounts: "",
            alimony: "",
            childSupport: "",
            others: " ",
            othersPlaceholder: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step3: {
            mainTitle: "",
            intoText: "",
            yesText: "",
            noText: "",
            yesTextFull: "",
            noTextFull: "",
            addText: "",
            monthyAmountText: "",
            monthyAmountPlaceholder: "",
            alimony: "",
            studentLoanInterest: "",
            childcare: "",
            others: "",
            othersPlaceholder: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step4: {
            mainTitle: "",
            intoText: "",
            yesText: "",
            noText: "",
            addText: "",
            monthyAmountText: "",
            monthyAmountPlaceholder: "",
            bankAccount: "",
            home: "",
            vehicle: "",
            others: " ",
            othersPlaceholder: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step5: {
            mainTitle: "",
            motivationText: "",
            callToActionText: ".",
            aditionalInfo: " ",
            nextBtn: "",
            prevBtn: "",
            endSession: " ",
          },
        },
        HouseHold: {
          Step1: {
            mainTitleBefore: "",
            relationshipLabel: "",
            firstNameLabel: "",
            lastNameLabel: "",
            genderLabel: "",
            inputPlaceholder: "",
            maleText: "",
            femaleText: "",
            ssnLabel: "",
            birthdateLabel: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
            errorValidationText: "",
            memberOptions: {
              select: "",
              spouse: "",
              parent: "",
              child: "",
              sibling: "",
              stepparent: "",
              stepchild: "",
              grandparent: "",
              grandchild: "",
              aunt: "",
              niece: "",
              cousin: "",
              other: " ",
            },
          },
          Step2: {
            mainTitleBefore: "",
            mainTitle: "",
            yesText: "",
            employerNameText: "",
            monthyIncomeText: "",
            monthyIncomePlaceholder: "",
            employerNamePlacehoder: "",
            addText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step3: {
            mainTitleBefore: "",
            mainTitle: "",
            yesText: "",
            noText: "",
            addText: "",
            monthyAmountText: "",
            monthyAmountPlaceholder: "",
            unemployment: "",
            socialSecurity: "",
            pensions: "",
            childSupport: "",
            retirementAccounts: "",
            alimony: "",
            others: "",
            othersPlaceholder: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step4: {
            mainTitleBefore: "",
            mainTitle: "",
            intoText: "",
            yesText: "",
            noText: "",
            yesTextFull: "",
            noTextFull: "",
            addText: "",
            monthyAmountText: "",
            monthyAmountPlaceholder: "",
            alimony: "",
            studentLoanInterest: "",
            childcare: "",
            others: " ",
            othersPlaceholder: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step5: {
            mainTitle: "",
            motivationText: "",
            callToActionText: "",
            aditionalInfo: " ",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
        },
        Documents: {
          Step1: {
            mainTitle: "",
            intoText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
            clearBtn: "",
          },
          Step2: {
            mainTitle: "",
            intoText: "",
            subTitle: "",
            sscText: "",
            upload: "",
            IdText: "",
            piText: "",
            noDocunmentsText: "",
            callToActionText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
            additionalDocumentsText: "Do you have more files to upload?",
            additionalDocumentsYesText: "Yes, I have",
            additionalDocumentsNoText: "No, continue",
            upload: "Upload",
            prText: "Proof of Residence",
          },
          Step3: {
            mainTitle: "",
            sectionTitle: "",
            phoneLabel: "",
            emailLabel: "",
            textMsgLabel: "",
            motivationText: "",
            phoneNumberText: "",
            emailText: "",
            domainText: "",
            aditionalInfo: "",
            nextBtn: "",
          },
        },
        NotFound: {
          siteName: "",
          mainTitle: "",
          aditionalInfo: "",
          footertext: "",
        },
        Logout: { mainTitle: "", yesText: "", noText: "" },
        Thankyou: {
          siteName: "",
          mainTitle: "",
          motivationText: "",
          phoneNumberText: "",
          emailText: "",
          domainText: "",
          logoutText: "",
        },
        Feedback: {
          siteName: "",
          mainTitle: "",
          labelText: "",
          placeholderText: "",
          nextBtn: "",
        },
      },
      es: {
        errorMsg: "Algo salió mal.\n Inténtalo de nuevo.",
        loginFailMsg: "Error: Access Denied ES",
        newCodeMsg: "",
        mm: "",
        dd: "",
        yy: "",
        months: {
          jan: "",
          feb: "",
          mar: "",
          apr: "",
          may: "",
          june: "",
          jul: "",
          aug: "",
          sep: "",
          oct: "",
          nov: "",
          dec: "",
        },
        loginPage: {
          mainTitle: "",
          companyName: "",
          intoText: "",
          formTitle: "",
          formTitleCode: "",
          codePlaceholder: "",
          deleteText: "",
          continueText: "",
          or: "",
        },
        Welcome: { helloText: "", intoText: "" },
        BirthdatePage: { mainTitle: "", formTitle: "", continueText: "" },
        InformationReviewPage: {
          mainTitle: "",
          intoText: "",
          formTitle: "",
          firstNameLabel: "",
          lastNameLabel: "",
          genderLabel: "",
          inputPlaceholder: "",
          maleText: "",
          femaleText: "",
          ssnLabel: "",
          phoneLabel: "",
          emailLabel: "",
          birthdateLabel: "",
          addressLabelLine1: "",
          addressLabelLine2: "",
          cityLabel: "",
          stateLabel: "",
          zipLabel: "",
          nextBtn: "",
          prevBtn: "",
          endSession: "",
        },
        GeneralInfo: {
          Step1: {
            mainTitle: "",
            yesText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step2: {
            mainTitle: "",
            yesText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step3: {
            mainTitle: "",
            yesText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step4: {
            mainTitle: "",
            yesText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step5: {
            mainTitle: "",
            yesText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step6: {
            mainTitle: "",
            intoText: "",
            spouseText: "",
            childrenText: "",
            otherDependentsText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step7: {
            mainTitle: "",
            aditionalInfo: "",
            aditionalInfoBottom: "",
            currencyText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step8: {
            leadText: "",
            mainTitle: "",
            intoText: "",
            motivationText: "",
            callToActionText: "",
            aditionalInfo: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
        },
        FinancialInfo: {
          Step1: {
            mainTitle: "",
            yesText: "",
            employerNameText: "",
            monthyIncomeText: "",
            monthyIncomePlaceholder: "",
            employerNamePlacehoder: "",
            addText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step2: {
            mainTitle: "",
            yesText: "",
            noText: "",
            addText: "",
            monthyAmountText: "",
            monthyAmountPlaceholder: "",
            unemployment: "",
            socialSecurity: "",
            pensions: "",
            retirementAccounts: "",
            alimony: "",
            childSupport: "",
            others: " ",
            othersPlaceholder: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step3: {
            mainTitle: "",
            intoText: "",
            yesText: "",
            noText: "",
            yesTextFull: "",
            noTextFull: "",
            addText: "",
            monthyAmountText: "",
            monthyAmountPlaceholder: "",
            alimony: "",
            studentLoanInterest: "",
            childcare: "",
            others: "",
            othersPlaceholder: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step4: {
            mainTitle: "",
            intoText: "",
            yesText: "",
            noText: "",
            addText: "",
            monthyAmountText: "",
            monthyAmountPlaceholder: "",
            bankAccount: "",
            home: "",
            vehicle: "",
            others: " ",
            othersPlaceholder: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step5: {
            mainTitle: "",
            motivationText: "",
            callToActionText: ".",
            aditionalInfo: " ",
            nextBtn: "",
            prevBtn: "",
            endSession: " ",
          },
        },
        HouseHold: {
          Step1: {
            mainTitleBefore: "",
            relationshipLabel: "",
            firstNameLabel: "",
            lastNameLabel: "",
            genderLabel: "",
            inputPlaceholder: "",
            maleText: "",
            femaleText: "",
            ssnLabel: "",
            birthdateLabel: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
            errorValidationText: "",
            memberOptions: {
              select: "",
              spouse: "",
              parent: "",
              child: "",
              sibling: "",
              stepparent: "",
              stepchild: "",
              grandparent: "",
              grandchild: "",
              aunt: "",
              niece: "",
              cousin: "",
              other: " ",
            },
          },
          Step2: {
            mainTitleBefore: "",
            mainTitle: "",
            yesText: "",
            employerNameText: "",
            monthyIncomeText: "",
            monthyIncomePlaceholder: "",
            employerNamePlacehoder: "",
            addText: "",
            noText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step3: {
            mainTitleBefore: "",
            mainTitle: "",
            yesText: "",
            noText: "",
            addText: "",
            monthyAmountText: "",
            monthyAmountPlaceholder: "",
            unemployment: "",
            socialSecurity: "",
            pensions: "",
            childSupport: "",
            retirementAccounts: "",
            alimony: "",
            others: "",
            othersPlaceholder: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step4: {
            mainTitleBefore: "",
            mainTitle: "",
            intoText: "",
            yesText: "",
            noText: "",
            yesTextFull: "",
            noTextFull: "",
            addText: "",
            monthyAmountText: "",
            monthyAmountPlaceholder: "",
            alimony: "",
            studentLoanInterest: "",
            childcare: "",
            others: " ",
            othersPlaceholder: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
          Step5: {
            mainTitle: "",
            motivationText: "",
            callToActionText: "",
            aditionalInfo: " ",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
          },
        },
        Documents: {
          Step1: {
            mainTitle: "",
            intoText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
            clearBtn: "",
          },
          Step2: {
            mainTitle: "",
            intoText: "",
            subTitle: "",
            sscText: "",
            upload: "",
            IdText: "",
            piText: "",
            noDocunmentsText: "",
            callToActionText: "",
            nextBtn: "",
            prevBtn: "",
            endSession: "",
            additionalDocumentsText: "Do you have more files to upload?",
            additionalDocumentsYesText: "Yes, I have",
            additionalDocumentsNoText: "No, continue",
            upload: "Upload",
            prText: "Proof of Residence",
          },
          Step3: {
            mainTitle: "",
            sectionTitle: "",
            phoneLabel: "",
            emailLabel: "",
            textMsgLabel: "",
            motivationText: "",
            phoneNumberText: "",
            emailText: "",
            domainText: "",
            aditionalInfo: "",
            nextBtn: "",
          },
        },
        NotFound: {
          siteName: "",
          mainTitle: "",
          aditionalInfo: "",
          footertext: "",
        },
        Logout: { mainTitle: "", yesText: "", noText: "" },
        Thankyou: {
          siteName: "",
          mainTitle: "",
          motivationText: "",
          phoneNumberText: "",
          emailText: "",
          domainText: "",
          logoutText: "",
        },
        Feedback: {
          siteName: "",
          mainTitle: "",
          labelText: "",
          placeholderText: "",
          nextBtn: "",
        },
      },
    },
    altLanguages: {
      Title: "",
      UseLogo: "true",
      Color: "",
      langs: {
        en: {
          loginPage: {
            mainTitle: "",
            companyName: "",
            intoText: "",
            formTitle: "",
            formTitleCode: "",
            codePlaceholder: "",
            haveCode: "",
            doNotHaveCode: "",
            deleteText: "",
            continueText: "",
          },
          Documents: {
            Step3: {
              mainTitle: "",
              sectionTitle: "",
              phoneLabel: "",
              emailLabel: "",
              textMsgLabel: "",
              motivationText: "",
              phoneNumberText: "",
              emailText: "",
              emailLink: "",
              domainText: "",
              domainLink: "",
              aditionalInfo: "",
              nextBtn: "",
            },
          },
          Thankyou: {
            siteName: "",
            mainTitle: "",
            motivationText: "",
            phoneNumberText: "",
            emailText: "",
            emailLink: "",
            domainText: "",
            domainLink: "",
            logoutText: "",
          },
        },
        es: {
          loginPage: {
            mainTitle: "",
            companyName: "",
            intoText: "",
            formTitle: "",
            formTitleCode: "",
            codePlaceholder: "",
            haveCode: "",
            doNotHaveCode: "",
            deleteText: "",
            continueText: "",
          },
          Documents: {
            Step3: {
              mainTitle: "",
              sectionTitle: "",
              phoneLabel: "",
              emailLabel: "",
              textMsgLabel: "",
              motivationText: "",
              phoneNumberText: "",
              emailText: "",
              emailLink: "",
              domainText: "",
              domainLink: "",
              aditionalInfo: "",
              nextBtn: "",
            },
          },
          Thankyou: {
            siteName: "",
            mainTitle: "",
            motivationText: "",
            phoneNumberText: "",
            emailText: "",
            emailLink: "",
            domainText: "",
            domainLink: "",
            logoutText: "",
          },
        },
      },
    },
    accessCode: "",
    round: 0,
    counter: 1,
    facilityId: "00000000-0000-0000-0000-000000000000",
    // memberCounter:{
    //     spouse:0,
    //     child:0,
    //     dependants:0
    // },
    personData: {
      firstName: "",
      lastName: "",
      gender: "",
      socialSecurityNumber: "",
      phone: "",
      email: "",
      birthday: {
        month: "",
        date: "",
        year: "",
      },
      address: {
        line1: "",
        line2: "",
        city: "",
        state: "",
        zipCode: "",
      },
    },
    generalInfo: {
      familyMembers: {
        spouse: 0,
        child: 0,
        dependants: 0,
      },
      houseHoldTotalIncome: 0,
    },
    financialInfo: {
      employersList: [],
      incomeList: {
        unemployment: "",
        socialSecurity: "",
        pensions: "",
        retirementAccounts: "",
        alimony: "",
        childSupport: "",
      },
      incomeListOthers: [{ name: "", value: "" }],
      expenseList: {
        alimony: "",
        studentLoanInterest: "",
        childcare: "",
      },
      expenseListOthers: [{ name: "", value: "" }],
      assetsList: {
        bankAccount: "",
        home: "",
        vehicle: "",
      },
      assetsListOthers: [{ name: "", value: "" }],
    },
    houseHoldInfo: [],
    documents: {
      signature: "",
      photoSsc: "",
      photoSscSize: "",
      photoId: "",
      photoIdSize: "",
      photoPi: "",
      photoPiSize: "",
      photoPR: "",
      photoPRSize: "",
    },
    feedback: {
      rating: "",
    },
    outreachRequestId: "00000000-0000-0000-0000-000000000000",
    src: ""
  };

  componentDidMount() {
    this.getLangs();
    this.getAltLang();

    // this.setState({
    //    languages:{
    //        en:LangsData.langs.en
    //    }
    // })

    if (JSON.parse(sessionStorage.getItem("languageCode"))) {
      this.setState({
        languageCode: JSON.parse(sessionStorage.getItem("languageCode")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("benefitRecordId"))) {
      this.setState({
        benefitRecordId: JSON.parse(sessionStorage.getItem("benefitRecordId")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("facilityId"))) {
      this.setState({
        facilityId: JSON.parse(sessionStorage.getItem("facilityId")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("accessCode"))) {
      this.setState({
        accessCode: JSON.parse(sessionStorage.getItem("accessCode")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("personData"))) {
      this.setState({
        personData: JSON.parse(sessionStorage.getItem("personData")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("generalInfo"))) {
      this.setState({
        generalInfo: JSON.parse(sessionStorage.getItem("generalInfo")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("financialInfo"))) {
      this.setState({
        financialInfo: JSON.parse(sessionStorage.getItem("financialInfo")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("houseHoldInfo"))) {
      this.setState({
        houseHoldInfo: JSON.parse(sessionStorage.getItem("houseHoldInfo")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("round"))) {
      this.setState({
        round: JSON.parse(sessionStorage.getItem("round")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("documents"))) {
      this.setState({
        documents: JSON.parse(sessionStorage.getItem("documents")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("feedback"))) {
      this.setState({
        feedback: JSON.parse(sessionStorage.getItem("feedback")),
      });
    }
    if (JSON.parse(sessionStorage.getItem("langCode"))) {
      this.setState({
        langCode: JSON.parse(sessionStorage.getItem("langCode")),
      });
    }
    // if(JSON.parse(sessionStorage.getItem("memberCounter"))) {
    //     this.setState({
    //         memberCounter: JSON.parse(sessionStorage.getItem("memberCounter"))
    //     })
    // }
    if (JSON.parse(sessionStorage.getItem("outreachRequestId"))) {
      this.setState({
        outreachRequestId: JSON.parse(sessionStorage.getItem("outreachRequestId"))
      });
    }
    if (JSON.parse(sessionStorage.getItem("src"))) {
      this.setState({
        src: JSON.parse(sessionStorage.getItem("src"))
      });
    }
  }

  // encodeLangs = langs => {
  //   let newLangs = { ...langs }
  //   Object.keys(newLangs).forEach(l => {
  //     Object.keys(newLangs[l]).forEach(k => {
  //       if (typeof newLangs[l][k] === "object") {
  //         Object.keys(newLangs[l][k]).forEach(innerKey => {
  //           console.log(newLangs[l][k][innerKey])
  //           newLangs[l][k][innerKey] = encode(`${newLangs[l][k][innerKey]}`)
  //         })
  //       } else {
  //         newLangs[l][k] = encode(newLangs[l][k])
  //       }
  //     })
  //   })
  //   return newLangs;
  // }

  // set to Api
  getLangs = () => {
    // const proxy = "https://cors-anywhere.herokuapp.com/";
    const proxy = "";
    const url = langData;
    fetch(proxy + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(),
    })
      .then((response) => response.json())
      .then((result) => {
        this.setState({
          // languages: this.encodeLangs(result.langs),
          languages: result.langs,
        });
      })
      .catch((e) => {
        this.setState({
          loading: false,
          loadingFail: true,
        });
      });
  };
  getAltLang = () => {
    // const proxy = "https://cors-anywhere.herokuapp.com/";
    const proxy = "";
    const url = langDataCustom;
    fetch(proxy + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(),
    })
      .then((response) => response.json())
      .then((result) => {
        this.setState({
          altLanguages: result,
        });
      })
      .catch((e) => {
        this.setState({
          loading: false,
          loadingFail: true,
        });
      });
  };
  // ------------ setToState ------------
  setLangCode = (languageCode) => {
    this.setCurrentLangCode(languageCode);
  };
  getUserRawData = (result) => {
    this.setCurrentLangCode(result.languageCode);
    this.setFacilityIdToSession(result.facilityId);

    let personData = {
      ...this.state.personData,
      firstName: result.personData.firstName,
      lastName: result.personData.lastName,
    };
    this.setPersonDataToSession(personData);
  };

  // setUserNames = (data) => {
  //     let personData = {
  //         ...this.state.personData,
  //         firstName:data.firstName,
  //         lastName:data.lastName,
  //         birthday:data.birthday,
  //         email:data.email,
  //         phone:data.phone
  //     }
  //     this.setPersonDataToSession(personData);
  // }

  setCurrentLangCode = (languageCode) => {
    sessionStorage.setItem("languageCode", JSON.stringify(languageCode));
    this.setState({
      languageCode: JSON.parse(sessionStorage.getItem("languageCode")),
    });
  };
  setBenefitRecordIdToSession = (benefitRecordId) => {
    sessionStorage.setItem("benefitRecordId", JSON.stringify(benefitRecordId));
    this.setState({
      benefitRecordId: JSON.parse(sessionStorage.getItem("benefitRecordId")),
    });
  };
  setFacilityIdToSession = (facilityId) => {
    sessionStorage.setItem("facilityId", JSON.stringify(facilityId));
    this.setState({
      facilityId: JSON.parse(sessionStorage.getItem("facilityId")),
    });
  };

  setToState = (result) => {
    this.setBenefitRecordIdToSession(result.benefitRecordId);
    this.setPersonDataToSession(result.personData);
    this.setGeneralInfoToSession(result.generalInfo);
    this.setDocumentsToSession(result.documents);
    this.setFeedbackToSession(result.feedback);
    this.setFacilityIdToSession(result.facilityId);

    this.setfinancialInfoToSession(result.financialInfo);
    this.setHouseHoldToSession(result.houseHoldInfo);

    let { email, phone } = result.personData;
    if (phone || email) {
      let contacts = {
        ...this.state.documents,
        email: email,
        phone: phone,
        message: phone,
      };
      this.setDocumentsToSession(contacts);
    }
  };

  setOutreachRequestId = (outreachRequestId) => {
    this.setState({
      outreachRequestId: JSON.parse(sessionStorage.getItem("outreachRequestId"))
    });
  }

  setSrc = (src) => {
    this.setState({
      src: JSON.parse(sessionStorage.getItem("src"))
    });
  }

  // set to Api
  sendToApi = (
    stateElement,
    obj,
    cb,
    sendFiles = false,
    uploadDocuments = false,
    redirect = () => { }
  ) => {
    this.setState({
      loading: true,
      loadingFail: false,
    });
    if (this.state.benefitRecordId.length > 1) {
      let data = {
        accessCode: this.state.accessCode,
        benefitRecordId: this.state.benefitRecordId,
        facilityId: this.state.facilityId,
        personData: this.state.personData,
        generalInfo: this.state.generalInfo,
        financialInfo: this.state.financialInfo,
        houseHoldInfo: this.state.houseHoldInfo,
        documents: this.state.documents,
        feedback: this.state.feedback,
        lastCompletedStep: window.location.pathname,
        outreachRequestId: this.state.outreachRequestId,
        src: this.state.src
      };
      const url = apiUrl;
      if(data.outreachRequestId == "" || null || undefined) { data.outreachRequestId = "00000000-0000-0000-0000-000000000000"}
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-api-key": "B9C1A34C-D284-4596-B0B5-478FF3E46E0D",
        },
        body: sendFiles
          ? JSON.stringify(data)
          : JSON.stringify({
            ...data,
            documents: {
              ...data.documents,
              photoId: "",
              photoIdSize: "",
              photoSsc: "",
              photoSscSize: "",
              photoPi: "",
              photoPiSize: "",
              photoPR: "",
              photoPRSize: "",
            },
          }),
      })
        .then((response) => response.json())
        .then((result) => {
          this.setState({
            loading: false,
            loadingFail: false,
          });
          let financialInfo;
          let houseHoldInfo;

          if (stateElement === "healthInsurance") {
            let documents = {
              ...this.state.documents,
              signature: "",
            };
            this.setDocumentsToSession(documents);
          }

          if (stateElement === "employed") {
            financialInfo = {
              ...this.state.financialInfo,
              employersList: result.financialInfo.employersList,
            };
            this.setfinancialInfoToSession(financialInfo);
          } else if (stateElement === "income") {
            financialInfo = {
              ...this.state.financialInfo,
              incomeList: result.financialInfo.incomeList,
              incomeListOthers: result.financialInfo.incomeListOthers,
            };
            this.setfinancialInfoToSession(financialInfo);
          } else if (stateElement === "expenses") {
            financialInfo = {
              ...this.state.financialInfo,
              expenseList: result.financialInfo.expenseList,
              expenseListOthers: result.financialInfo.expenseListOthers,
            };
            this.setfinancialInfoToSession(financialInfo);
          } else if (stateElement === "assets") {
            financialInfo = {
              ...this.state.financialInfo,
              assetsList: result.financialInfo.assetsList,
              assetsListOthers: result.financialInfo.assetsListOthers,
            };
            this.setfinancialInfoToSession(financialInfo);
          } else if (stateElement === "familyMembers") {
            houseHoldInfo = result.houseHoldInfo;
            this.setHouseHoldToSession(houseHoldInfo);
          }

          // let financialInfo = {
          //     ...this.state.financialInfo,
          //     employersList:result.financialInfo.employersList,
          //     incomeList:result.financialInfo.incomeList,
          //     incomeListOthers:result.financialInfo.incomeListOthers,
          //     expenseList:result.financialInfo.expenseList,
          //     expenseListOthers:result.financialInfo.expenseListOthers,
          //     assetsList:result.financialInfo.assetsList,
          //     assetsListOthers:result.financialInfo.assetsListOthers,
          // }
          // this.setfinancialInfoToSession(financialInfo)

          if (stateElement === "generalData" && obj === "household") {
            houseHoldInfo = this.state.houseHoldInfo.map((el, i) => {
              return {
                personData: result.houseHoldInfo[i].personData,
                financialInfo: this.state.houseHoldInfo[i].financialInfo,
              };
            });
            this.setHouseHoldToSession(houseHoldInfo);
          } else if (stateElement === "employed" && obj === "household") {
            houseHoldInfo = this.state.houseHoldInfo.map((el, i) => {
              return {
                personData: this.state.houseHoldInfo[i].personData,
                financialInfo: {
                  ...this.state.houseHoldInfo[i].financialInfo,
                  employersList:
                    result.houseHoldInfo[i].financialInfo.employersList,
                },
              };
            });
            this.setHouseHoldToSession(houseHoldInfo);
          } else if (stateElement === "income" && obj === "household") {
            houseHoldInfo = this.state.houseHoldInfo.map((el, i) => {
              return {
                personData: this.state.houseHoldInfo[i].personData,
                financialInfo: {
                  ...this.state.houseHoldInfo[i].financialInfo,
                  incomeList: result.houseHoldInfo[i].financialInfo.incomeList,
                  incomeListOthers:
                    result.houseHoldInfo[i].financialInfo.incomeListOthers,
                },
              };
            });
            this.setHouseHoldToSession(houseHoldInfo);
          } else if (stateElement === "expenses" && obj === "household") {
            houseHoldInfo = this.state.houseHoldInfo.map((el, i) => {
              return {
                personData: this.state.houseHoldInfo[i].personData,
                financialInfo: {
                  ...this.state.houseHoldInfo[i].financialInfo,
                  expenseList:
                    result.houseHoldInfo[i].financialInfo.expenseList,
                  expenseListOthers:
                    result.houseHoldInfo[i].financialInfo.expenseListOthers,
                },
              };
            });
            this.setHouseHoldToSession(houseHoldInfo);
          }
          // let houseHoldInfo = this.state.houseHoldInfo.map( (el , i)  =>{
          //     return {
          //         personData:this.state.houseHoldInfo[i].personData,
          //         financialInfo:{
          //                 ...this.state.houseHoldInfo[i].financialInfo,
          //                 employersList:result.houseHoldInfo[i].financialInfo.employersList,
          //                 incomeList:result.houseHoldInfo[i].financialInfo.incomeList,
          //                 incomeListOthers:result.houseHoldInfo[i].financialInfo.incomeListOthers,
          //                 expenseList:result.houseHoldInfo[i].financialInfo.expenseList,
          //                 expenseListOthers:result.houseHoldInfo[i].financialInfo.expenseListOthers
          //             }
          //     }
          // });
          // this.setHouseHoldToSession(houseHoldInfo)
          if (uploadDocuments) {
            this.showConfirmNewDocuments();
            // this.setState({
            //   confirmNewDocuments: true,
            //   redirect
            // });
          } else if (cb) {
            cb();
          }
        })
        .catch((e) => {
          this.setState({
            loading: false,
            loadingFail: true,
          });
        });
    } else {
      this.endSession();
      return (window.location.href = "/");
    }
  };

  //show confirm new documents
  showConfirmNewDocuments = () => {
    this.setState({
      confirmNewDocuments: true,
    });
  };

  //hide confirm new documents
  closeConfirmNewDocuments = () => {
    this.setState({
      confirmNewDocuments: false,
    });
  };

  // login fail
  loginFail = () => {
    this.setState({
      loginFail: true,
      loading: false,
    });
  };

  // login fail
  startLoading = () => {
    this.setState({
      loading: true,
    });
  };

  loginSuccess = () => {
    this.setState({
      loginFail: false,
      loading: false,
    });
  };

  // ------------ set access code ------------
  setAccessCode = (accessCode) => {
    this.setAccessCodeToSession(accessCode);
  };

  // ------------set access code to session----------------------

  setAccessCodeToSession = (accessCode) => {
    sessionStorage.setItem("accessCode", JSON.stringify(accessCode));
    this.setState({
      accessCode: JSON.parse(sessionStorage.getItem("accessCode")),
    });
  };

  // ------------all steps--------------------
  setCompleteLevel = (completed) => {
    this.setState({ completed });
  };

  // ------------Information Reivew----------------------
  handleChange = (event) => {
    const { name, value } = event.target;

    let personData = {
      ...this.state.personData,
      [name]: value,
    };

    if (name == "email") {
      let contacts = {
        ...this.state.documents,
        [name]: value,
      };
      this.setDocumentsToSession(contacts);
    } else if (name == "phone") {
      let contacts = {
        ...this.state.documents,
        phone: value,
        message: value,
      };
      this.setDocumentsToSession(contacts);
    }

    this.setPersonDataToSession(personData);
  };

  // ------------Date verification----------------------
  handleChangeDate = (event) => {
    const { name, value } = event.target;
    let personData = {
      ...this.state.personData,
      birthday: {
        ...this.state.personData.birthday,
        [name]: value,
      },
    };
    this.setPersonDataToSession(personData);
  };

  handleChangeGender = (event) => {
    const { name, value } = event.target;
    let personData = {
      ...this.state.personData,
      [name]: value,
    };
    this.setPersonDataToSession(personData);
  };

  handleChangeAddress = (event) => {
    const { name, value } = event.target;
    let personData = {
      ...this.state.personData,
      address: {
        ...this.state.personData.address,
        [name]: value,
      },
    };
    this.setPersonDataToSession(personData);
  };
  // ------------General Info Set to session----------------------
  setPersonDataToSession = (personData) => {
    sessionStorage.setItem("personData", JSON.stringify(personData));
    this.setState({
      personData: JSON.parse(sessionStorage.getItem("personData")),
    });
  };

  // ------------General Info Step 1, 2, 3, 4, 5----------------------
  handleCheckboxClick = (el, value) => {
    if (el.stateElement == "gender") {
      let personData = {
        ...this.state.personData,
        [el.stateElement]: value,
      };
      this.setPersonDataToSession(personData);
    }
    let generalInfo = {
      ...this.state.generalInfo,
      [el.stateElement]: value,
    };

    this.setGeneralInfoToSession(generalInfo);
  };

  // ------------General Info Step 6----------------------
  handleFamilyMemberChange = (event) => {
    const { name, value } = event.target;
    let generalInfo = {
      ...this.state.generalInfo,
      familyMembers: {
        ...this.state.generalInfo.familyMembers,
        [name]: value,
      },
    };
    this.setGeneralInfoToSession(generalInfo);
  };

  decreaseFamilyMember = (value, name) => {
    if (value !== 0) {
      value -= 1;
      this.setInitialStateHouseHold("decrease", name);
    }

    let generalInfo = {
      ...this.state.generalInfo,
      familyMembers: {
        ...this.state.generalInfo.familyMembers,
        [name]: value,
      },
    };
    this.setGeneralInfoToSession(generalInfo);
  };

  increaseFamilyMember = (value, name) => {
    if (name == "spouse" && value < 1) {
      value += 1;
      this.setInitialStateHouseHold("increase", name);
    } else if (name !== "spouse" && value < 9) {
      value += 1;
      this.setInitialStateHouseHold("increase", name);
    }

    let generalInfo = {
      ...this.state.generalInfo,
      familyMembers: {
        ...this.state.generalInfo.familyMembers,
        [name]: value,
      },
    };

    this.setGeneralInfoToSession(generalInfo);
  };

  // ------------General Info Step 7----------------------
  handleChangeSilder = (event, newValue) => {
    let generalInfo = {
      ...this.state.generalInfo,
      houseHoldTotalIncome: newValue || 0
    };

    this.setGeneralInfoToSession(generalInfo);
  };

  // ------------General Info Set to session----------------------
  setGeneralInfoToSession = (generalInfo) => {
    sessionStorage.setItem("generalInfo", JSON.stringify(generalInfo));
    this.setState({
      generalInfo: JSON.parse(sessionStorage.getItem("generalInfo")),
    });
  };

  // ------------Finantial Info  ----------------------

  handleCheckboxDropdown = (el, value) => {
    let financialInfo = {
      ...this.state.financialInfo,
      [el.stateElement]: value,
    };

    this.setfinancialInfoToSession(financialInfo);
  };

  generateEmptyEmployerObj = () => {
    if (this.state.financialInfo.employersList == "") {
      let financialInfo = {
        ...this.state.financialInfo,
        employersList: [{ name: "", value: "" }],
      };
      this.setfinancialInfoToSession(financialInfo);
    }
  };

  // ------------Finantial Info Income----------------------
  handleIncomeChange = (event, stateForUpdate) => {
    const { name, value } = event.target;

    let financialInfo = {
      ...this.state.financialInfo,
      [stateForUpdate]: {
        ...this.state.financialInfo[stateForUpdate],
        [name]: value,
      },
    };
    this.setfinancialInfoToSession(financialInfo);
  };

  handleRowClick = (inputName, stateForUpdate, val) => {
    let financialInfo = {
      ...this.state.financialInfo,
      [stateForUpdate]: {
        ...this.state.financialInfo[stateForUpdate],
        [inputName]: val,
      },
    };
    this.setfinancialInfoToSession(financialInfo);
  };

  addRow = (event, stateObjName) => {
    let prevObjIndex = this.state.financialInfo[stateObjName].length;

    let prevObjName;
    let prevObjValue;
    if (prevObjIndex > 0) {
      prevObjName = this.state.financialInfo[stateObjName][prevObjIndex - 1]
        .name;
      prevObjValue = this.state.financialInfo[stateObjName][prevObjIndex - 1]
        .value;

      if (prevObjValue !== "" && prevObjName !== "") {
        this.aRFin(event, stateObjName);
      }
    } else {
      this.aRFin(event, stateObjName);
    }
  };

  aRFin = (event, stateObjName) => {
    let financialInfo = {
      ...this.state.financialInfo,
      [stateObjName]: [
        ...this.state.financialInfo[stateObjName],
        { name: "", value: "", id: "00000000-0000-0000-0000-000000000000" },
      ],
    };
    this.setfinancialInfoToSession(financialInfo);
  };

  handleName = (event, index, stateObjName) => {
    let { value } = event.target;
    let values = [...this.state.financialInfo[stateObjName]];
    values[index].name = value;
    let financialInfo = {
      ...this.state.financialInfo,
      [stateObjName]: values,
    };

    this.setfinancialInfoToSession(financialInfo);
  };

  handleAmount = (event, index, stateObjName) => {
    let { value } = event.target;
    let values = [...this.state.financialInfo[stateObjName]];
    values[index].value = value;
    let financialInfo = {
      ...this.state.financialInfo,
      [stateObjName]: values,
    };

    this.setfinancialInfoToSession(financialInfo);
  };

  removeRow = (index, stateObjName) => {
    let values = [...this.state.financialInfo[stateObjName]];
    values.splice(index, 1);
    let financialInfo = {
      ...this.state.financialInfo,
      [stateObjName]: values,
    };

    this.setfinancialInfoToSession(financialInfo);
  };

  // ------------Finantial Info Set to session----------------------
  setfinancialInfoToSession = (financialInfo) => {
    sessionStorage.setItem("financialInfo", JSON.stringify(financialInfo));
    this.setState({
      financialInfo: JSON.parse(sessionStorage.getItem("financialInfo")),
    });
  };

  // --------------------Household --------------------------

  setRound = (round) => {
    sessionStorage.setItem("round", JSON.stringify(round));
    this.setState({
      round: JSON.parse(sessionStorage.getItem("round")),
    });
  };

  setInitialStateHouseHold = (val, name) => {
    let relationship = "";

    if (name == "spouse") {
      relationship = "Spouse";
    } else if (name == "child") {
      relationship = "Child";
    }

    let initialState = {
      personData: {
        relationship: relationship,
        firstName: "",
        lastName: "",
        gender: "",
        socialSecurityNumber: "",
        birthday: {
          month: "",
          date: "",
          year: "",
        },
      },
      financialInfo: {
        employersList: [],
        incomeList: {
          unemployment: "",
          socialSecurity: "",
          pensions: "",
          retirementAccounts: "",
          alimony: "",
          childSupport: "",
        },
        incomeListOthers: [],
        expenseList: {
          alimony: "",
          studentLoanInterest: "",
          childcare: "",
        },
        expenseListOthers: [],
        assetsList: {
          bankAccount: "",
          home: "",
          vehicle: "",
        },
        assetsListOthers: [],
      },
    };
    if (val == "increase") {
      let houseHoldInfo = [...this.state.houseHoldInfo, initialState];
      this.setHouseHoldToSession(houseHoldInfo);
    } else if (val == "decrease") {
      let houseHoldInfo = this.state.houseHoldInfo;
      let rel = "";
      if (name == "spouse") {
        rel = "Spouse";
      } else if (name == "child") {
        rel = "Child";
      }
      for (var i = houseHoldInfo.length - 1; i >= 0; --i) {
        if (houseHoldInfo[i].personData.relationship == rel) {
          houseHoldInfo.splice(i, 1);
          break;
        }
      }
      this.setHouseHoldToSession(houseHoldInfo);
    }
  };

  handleMemberInfo = (event, round) => {
    const { name, value } = event.target;
    let prevValue = this.state.houseHoldInfo[round].personData.relationship;
    let houseHoldInfo = [...this.state.houseHoldInfo];

    houseHoldInfo[round] = {
      ...houseHoldInfo[round],
      personData: {
        ...this.state.houseHoldInfo[round].personData,
        [name]: value,
      },
    };
    // if(name=='relationship'){

    //     if (value=='Spouse') {
    //         this.memberCounter('increase', 'spouse')
    //     }
    //     if (value=='Child') {
    //         this.memberCounter('increase', 'child')
    //     }
    //     if (value!=='Spouse' && value!=='Child') {
    //         this.memberCounter('increase', 'dependants')
    //     }

    //     if(prevValue=='Spouse' && value!=='Spouse'){
    //         this.memberCounter('decrease', 'spouse')
    //     }
    //     if(prevValue=='Child' && value!=='Child'){
    //         this.memberCounter('decrease', 'child')
    //     }
    //     if(prevValue!=='Child' && value!=='Child' && prevValue!=='Spouse' && value!=='Spouse'){
    //         this.memberCounter('decrease', 'dependants')
    //     }
    // }
    this.setHouseHoldToSession(houseHoldInfo);
  };

  // setInitalFamilyMember = () =>{
  //     const {spouse, child, dependants}=this.state.generalInfo.familyMembers;

  //     let houseHoldInfo = [...this.state.houseHoldInfo];
  //     const {memberCounter, round}=this.state;
  //     let {relationship}=this.state.houseHoldInfo[round].personData

  //     if (!relationship && memberCounter.spouse<spouse && 0<spouse){
  //         houseHoldInfo[round] = {
  //             ...houseHoldInfo[round],
  //             personData :{
  //                 ...this.state.houseHoldInfo[round].personData,
  //                 relationship:'Spouse'
  //             }
  //         }
  //         this.memberCounter('increase', 'spouse')

  //     }else if(!relationship && memberCounter.child<child && 0<child){
  //         houseHoldInfo[round] = {
  //             ...houseHoldInfo[round],
  //             personData :{
  //                 ...this.state.houseHoldInfo[round].personData,
  //                 relationship:'Child'
  //             }
  //         }
  //         this.memberCounter('increase', 'child')
  //     }else if(!relationship && memberCounter.dependants<dependants && 0<dependants){
  //         this.memberCounter('increase', 'dependants')
  //     }
  //     this.setHouseHoldToSession(houseHoldInfo)
  // }

  // memberCounter = (action, relationship) =>{
  //     let memberCounter;
  //     if(action=="increase"){
  //         memberCounter = {
  //             ...this.state.memberCounter,
  //             [relationship]:this.state.memberCounter[relationship]+=1,
  //         }
  //     }else if(action=="decrease"){
  //         memberCounter = {
  //             ...this.state.memberCounter,
  //             [relationship]:this.state.memberCounter[relationship]-=1,
  //         }
  //     }
  //     this.setMemberCounter(memberCounter)
  // }

  handleMemberInfoDate = (event, round) => {
    const { name, value } = event.target;

    let houseHoldInfo = [...this.state.houseHoldInfo];
    houseHoldInfo[round] = {
      ...houseHoldInfo[round],
      personData: {
        ...this.state.houseHoldInfo[round].personData,
        birthday: {
          ...this.state.houseHoldInfo[round].personData.birthday,
          [name]: value,
        },
      },
    };
    this.setHouseHoldToSession(houseHoldInfo);
  };

  handleCheckboxDropdownHousehold = (el, value, round) => {
    let houseHoldInfo = [...this.state.houseHoldInfo];

    houseHoldInfo[round] = {
      ...houseHoldInfo[round],
      financialInfo: {
        ...this.state.houseHoldInfo[round].financialInfo,
        [el.stateElement]: value,
      },
    };

    this.setHouseHoldToSession(houseHoldInfo);
  };

  generateEmptyEmployerObjHouseHold = (round) => {
    if (this.state.houseHoldInfo[round].financialInfo.employersList == "") {
      let houseHoldInfo = [...this.state.houseHoldInfo];

      houseHoldInfo[round] = {
        ...houseHoldInfo[round],
        financialInfo: {
          ...this.state.houseHoldInfo[round].financialInfo,
          employersList: [{ name: "", value: "" }],
        },
      };

      this.setHouseHoldToSession(houseHoldInfo);
    }
  };

  handleIncomeChangeHousehold = (event, stateForUpdate, round) => {
    let houseHoldInfo = [...this.state.houseHoldInfo];
    const { name, value } = event.target;
    houseHoldInfo[round] = {
      ...houseHoldInfo[round],
      financialInfo: {
        ...this.state.houseHoldInfo[round].financialInfo,
        [stateForUpdate]: {
          ...this.state.houseHoldInfo[round].financialInfo[stateForUpdate],
          [name]: value,
        },
      },
    };
    this.setHouseHoldToSession(houseHoldInfo);
  };

  handleRowClickHousehold = (inputName, stateForUpdate, val, round) => {
    let houseHoldInfo = [...this.state.houseHoldInfo];

    houseHoldInfo[round] = {
      ...houseHoldInfo[round],
      financialInfo: {
        ...this.state.houseHoldInfo[round].financialInfo,
        [stateForUpdate]: {
          ...this.state.houseHoldInfo[round].financialInfo[stateForUpdate],
          [inputName]: val,
        },
      },
    };
    this.setHouseHoldToSession(houseHoldInfo);
  };

  addRowHousehold = (event, stateObjName, round) => {
    let prevObjIndex = this.state.houseHoldInfo[round].financialInfo[
      stateObjName
    ].length;

    let prevObjName;
    let prevObjValue;

    if (prevObjIndex > 0) {
      prevObjName = this.state.houseHoldInfo[round].financialInfo[stateObjName][
        prevObjIndex - 1
      ].name;
      prevObjValue = this.state.houseHoldInfo[round].financialInfo[
        stateObjName
      ][prevObjIndex - 1].value;

      if (prevObjValue !== "" && prevObjName !== "") {
        this.aRFinHousehold(event, stateObjName, round);
      }
    } else {
      this.aRFinHousehold(event, stateObjName, round);
    }
  };

  aRFinHousehold = (event, stateObjName, round) => {
    let houseHoldInfo = [...this.state.houseHoldInfo];

    houseHoldInfo[round] = {
      ...houseHoldInfo[round],
      financialInfo: {
        ...this.state.houseHoldInfo[round].financialInfo,
        [stateObjName]: [
          ...this.state.houseHoldInfo[round].financialInfo[stateObjName],
          { name: "", value: "", id: "00000000-0000-0000-0000-000000000000" },
        ],
      },
    };

    this.setHouseHoldToSession(houseHoldInfo);
  };

  handleNameHousehold = (event, index, stateObjName, round) => {
    let houseHoldInfo = [...this.state.houseHoldInfo];

    let { value } = event.target;
    let values = [
      ...this.state.houseHoldInfo[round].financialInfo[stateObjName],
    ];
    values[index].name = value;

    houseHoldInfo[round] = {
      ...houseHoldInfo[round],
      financialInfo: {
        ...this.state.houseHoldInfo[round].financialInfo,
        [stateObjName]: values,
      },
    };

    this.setHouseHoldToSession(houseHoldInfo);
  };

  handleAmountHousehold = (event, index, stateObjName, round) => {
    let houseHoldInfo = [...this.state.houseHoldInfo];

    let { value } = event.target;
    let values = [
      ...this.state.houseHoldInfo[round].financialInfo[stateObjName],
    ];
    values[index].value = value;
    houseHoldInfo[round] = {
      ...houseHoldInfo[round],
      financialInfo: {
        ...this.state.houseHoldInfo[round].financialInfo,
        [stateObjName]: values,
      },
    };

    this.setHouseHoldToSession(houseHoldInfo);
  };

  removeRowHousehold = (index, stateObjName, round) => {
    let houseHoldInfo = [...this.state.houseHoldInfo];
    let values = [
      ...this.state.houseHoldInfo[round].financialInfo[stateObjName],
    ];
    values.splice(index, 1);
    houseHoldInfo[round] = {
      ...houseHoldInfo[round],
      financialInfo: {
        ...this.state.houseHoldInfo[round].financialInfo,
        [stateObjName]: values,
      },
    };

    this.setHouseHoldToSession(houseHoldInfo);
  };

  //  ------------HouseHold Set to session----------------------
  // setMemberCounter = memberCounter => {
  //     sessionStorage.setItem("memberCounter", JSON.stringify(memberCounter));
  //     this.setState({
  //         memberCounter: JSON.parse(sessionStorage.getItem("memberCounter"))
  //    })
  // }
  //  ------------HouseHold Set to session----------------------
  setHouseHoldToSession = (houseHoldInfo) => {
    sessionStorage.setItem("houseHoldInfo", JSON.stringify(houseHoldInfo));
    this.setState({
      houseHoldInfo: JSON.parse(sessionStorage.getItem("houseHoldInfo")),
    });
  };

  //  ------------Documents pages ----------------------

  saveSignature = (img) => {
    let documents = {
      ...this.state.documents,
      signature: img,
    };
    this.setDocumentsToSession(documents);
  };

  clearignature = () => {
    let documents = {
      ...this.state.documents,
      signature: "",
    };
    this.setDocumentsToSession(documents);
  };

  handlePhotoSend = (event) => {
    const { name } = event.target;

    let reader = new FileReader();
    let file = event.target.files[0];
    let fileSize = file.size;

    let propSize = [name] + "Size";

    reader.readAsDataURL(file);
    reader.onload = () => {
      let documents = {
        ...this.state.documents,
        [name]: reader.result,
        [propSize]: Math.round(fileSize / 1000) + " Kb",
      };

      this.setState({
        documents,
        loading: true,
        loadingFail: false,
        innerLoader: true
      });

      let data = {
        accessCode: this.state.accessCode,
        benefitRecordId: this.state.benefitRecordId,
        facilityId: this.state.facilityId,
        personData: this.state.personData,
        generalInfo: this.state.generalInfo,
        financialInfo: this.state.financialInfo,
        houseHoldInfo: this.state.houseHoldInfo,
        documents,
        feedback: this.state.feedback,
        lastCompletedStep: window.location.pathname,
        outreachRequestId: this.state.outreachRequestId,
        src: this.state.src
      };
      const url = apiUrl;
      if(data.outreachRequestId == "" || null || undefined) { data.outreachRequestId = "00000000-0000-0000-0000-000000000000"}
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-api-key": "B9C1A34C-D284-4596-B0B5-478FF3E46E0D",
        },
        body: JSON.stringify(data)
      })
        .then((response) => response.json())
        .then((result) => {
          this.setState({
            loading: false,
            loadingFail: false,
            innerLoader: false
          });
          this.showConfirmNewDocuments();
        })

        .catch((e) => {
          this.setState({
            loading: false,
            loadingFail: true,
            innerLoader: false
          });
        });
    };
  };

  removePhoto = (name) => {
    let propSize = [name] + "Size";
    let documents = {
      ...this.state.documents,
      [name]: "",
      [propSize]: "",
    };
    this.setState({
      documents: documents,
    });
  };

  handleChangeContacts = (event) => {
    let { name, value } = event.target;
    let documents = {
      ...this.state.documents,
      [name]: value,
    };
    this.setDocumentsToSession(documents);
  };
  handleRowClickContacts = (inputName, val) => {
    let documents = {
      ...this.state.documents,
      [inputName]: val,
    };
    this.setDocumentsToSession(documents);
  };
  //  ------------Documents Set to session----------------------
  setDocumentsToSession = (documents) => {
    sessionStorage.setItem("documents", JSON.stringify(documents));
    this.setState({
      documents: JSON.parse(sessionStorage.getItem("documents")),
    });
  };

  // ---------------------- Feedback -------------------------------

  handleRaiting = (event, value) => {
    let { name } = event.target;
    let feedback = {
      ...this.state.feedback,
      [name]: value,
    };
    this.setFeedbackToSession(feedback);
  };

  handleFeedback = (event) => {
    let { name, value } = event.target;

    let feedback = {
      ...this.state.feedback,
      [name]: value,
    };
    this.setFeedbackToSession(feedback);
  };

  //  ------------Feedback Set to session----------------------
  setFeedbackToSession = (feedback) => {
    sessionStorage.setItem("feedback", JSON.stringify(feedback));
    this.setState({
      feedback: JSON.parse(sessionStorage.getItem("feedback")),
    });
  };

  // ------------------End Session---------------------------------

  endSession = () => {
    this.setState({
      accessCode: "",
      round: 0,
      counter: 1,
      // memberCounter:{
      //     spouse:0,
      //     child:0,
      //     dependants:0
      // },
      languageCode: "",
      // languages:{
      //     en:{loginPage:{mainTitle:'',companyName:'',intoText:'',formTitle:'',codePlaceholder:'',deleteText:'',continueText:''},Welcome:{helloText:'',intoText:""},BirthdatePage:{mainTitle:'',formTitle:'',continueText:''},InformationReviewPage:{mainTitle:'',intoText:'',formTitle:'',firstNameLabel:'',lastNameLabel:'',genderLabel:'',inputPlaceholder:'',maleText:"",femaleText:"",ssnLabel:'',phoneLabel:'',emailLabel:'',birthdateLabel:'',addressLabelLine1:'',addressLabelLine2:'',cityLabel:'',stateLabel:'',zipLabel:'',nextBtn:'',prevBtn:'',endSession:''},GeneralInfo:{Step1:{mainTitle:'',yesText:'',noText:'',nextBtn:'Nxt',prevBtn:'',endSession:''},Step2:{mainTitle:'',yesText:'',noText:'',nextBtn:'',prevBtn:'',endSession:''},Step3:{mainTitle:'',yesText:'',noText:'',nextBtn:'',prevBtn:'',endSession:''},Step4:{mainTitle:'',yesText:'',noText:'',nextBtn:'',prevBtn:'',endSession:''},Step5:{mainTitle:'',yesText:'',noText:'',nextBtn:'',prevBtn:'',endSession:''},Step6:{mainTitle:'',intoText:'',spouseText:'',childrenText:'',otherDependentsText:'',nextBtn:'',prevBtn:'',endSession:''},Step7:{mainTitle:'',aditionalInfo:'',aditionalInfoBottom:'',currencyText:'',nextBtn:'',prevBtn:'',endSession:''},Step8:{leadText:'',mainTitle:'',intoText:'',motivationText:'',callToActionText:'',aditionalInfo:'',nextBtn:'',prevBtn:'',endSession:''}},financialInfo:{Step1:{mainTitle:'',yesText:'',employerNameText:'',monthyIncomeText:'',monthyIncomePlaceholder:'',employerNamePlacehoder:'',addText:'',noText:'',nextBtn:'',prevBtn:'',endSession:''},Step2:{mainTitle:'',yesText:'',noText:'',addText:'',monthyAmountText:'',monthyAmountPlaceholder:'',unemployment:'Unemployent',socialSecurity:'',pensions:'',retirementAccounts:'',alimony:'',childSupport:'',others:' ',othersPlaceholder:'',nextBtn:'',prevBtn:'',endSession:''},Step3:{mainTitle:'',intoText:'',yesText:'',noText:'',yesTextFull:'',noTextFull:'',addText:'',monthyAmountText:'',monthyAmountPlaceholder:'',alimony:'',studentLoanInterest:'',childcare:'',others:'',othersPlaceholder:'',nextBtn:'',prevBtn:'',endSession:''},Step4:{mainTitle:'',intoText:'',yesText:'',noText:'',addText:'',monthyAmountText:'',monthyAmountPlaceholder:'',bankAccount:'',home:'',vehicle:'',others:' ',othersPlaceholder:'',nextBtn:'',prevBtn:'',endSession:''},Step5:{mainTitle:'',motivationText:'',callToActionText:'.',aditionalInfo:' ',nextBtn:'',prevBtn:'',endSession:' '}},HouseHold:{Step1:{mainTitleBefore:'',relationshipLabel:'',firstNameLabel:'',lastNameLabel:'',genderLabel:'',inputPlaceholder:'',maleText:"",femaleText:"",ssnLabel:'',birthdateLabel:'',nextBtn:'',prevBtn:'',endSession:'',errorValidationText:'',memberOptions:{select:'',spouse:'',parent:'',child:'',sibling:'',stepparent:'',stepchild:'',grandparent:'',grandchild:'',aunt:'',niece:'',cousin:'',other:' '}},Step2:{mainTitleBefore:'',mainTitle:'',yesText:'',employerNameText:'',monthyIncomeText:'',monthyIncomePlaceholder:'',employerNamePlacehoder:'',addText:'',noText:'',nextBtn:'',prevBtn:'',endSession:''},Step3:{mainTitleBefore:'',mainTitle:'',yesText:'',noText:'',addText:'',monthyAmountText:'',monthyAmountPlaceholder:'',unemployment:'',socialSecurity:'',pensions:'',retirementAccounts:'',alimony:'',others:'',othersPlaceholder:'',nextBtn:'',prevBtn:'',endSession:''},Step4:{mainTitleBefore:'',mainTitle:'',intoText:'',yesText:'',noText:'',yesTextFull:'',noTextFull:'',addText:'',monthyAmountText:'',monthyAmountPlaceholder:'',alimony:'',studentLoanInterest:'',childcare:'',others:' ',othersPlaceholder:'',nextBtn:'',prevBtn:'',endSession:''},Step5:{mainTitle:'',motivationText:'',callToActionText:'',aditionalInfo:' ',nextBtn:'',prevBtn:'',endSession:''}},Documents:{Step1:{mainTitle:'',intoText:'',nextBtn:'',prevBtn:'',endSession:'',clearBtn:''},Step2:{mainTitle:'',intoText:'',subTitle:'',sscText:'',IdText:'',piText:'',noDocunmentsText:'',callToActionText:'',nextBtn:'',prevBtn:'',endSession:'',},Step3:{mainTitle:'',sectionTitle:'',phoneLabel:'',emailLabel:'',textMsgLabel:'',motivationText:"",phoneNumberText:'',emailText:"",domainText:'',aditionalInfo:'',nextBtn:'',}},NotFound:{siteName:'',mainTitle:'',aditionalInfo:'',footertext:''},Logout:{mainTitle:'',yesText:'',noText:'',},Thankyou:{siteName:'',mainTitle:'',motivationText:"",phoneNumberText:'',emailText:"",domainText:'',logoutText:''},Feedback:{siteName:'',mainTitle:'',labelText:'',placeholderText:'',nextBtn:'',}}
      // },
      facilityId: "00000000-0000-0000-0000-000000000000",
      benefitRecordId: "",
      personData: {
        firstName: "",
        lastName: "",
        gender: "",
        socialSecurityNumber: "",
        phone: "",
        email: "",
        birthday: {
          month: "",
          date: "",
          year: "",
        },
        address: {
          line1: "",
          line2: "",
          city: "",
          state: "",
          zipCode: "",
        },
      },
      generalInfo: { familyMembers: { spouse: 0, child: 0, dependants: 0 } },
      financialInfo: {
        employersList: [],
        incomeList: {
          unemployment: "",
          socialSecurity: "",
          pensions: "",
          retirementAccounts: "",
          alimony: "",
          childSupport: "",
        },
        incomeListOthers: [],
        expenseList: { alimony: "", studentLoanInterest: "", childcare: "" },
        expenseListOthers: [],
        assetsList: { bankAccount: "", home: "", vehicle: "" },
        assetsListOthers: [],
      },
      houseHoldInfo: [],
      documents: {
        signature: "",
        photoSsc: "",
        photoSscSize: "",
        photoId: "",
        photoIdSize: "",
        photoPi: "",
        photoPiSize: "",
        photoPR: "",
        photoPRSize: "",
        email: "",
        phone: "",
        message: "",
      },
      feedback: { rating: "" },
      lastCompletedStep: "",
      outreachRequestId: "",
      src: ""
    });

    // this.getLangs()
    sessionStorage.removeItem("accessCode");
    sessionStorage.removeItem("skipDOB");
    sessionStorage.removeItem("benefitRecordId");
    sessionStorage.removeItem("facilityId");
    sessionStorage.removeItem("personData");
    sessionStorage.removeItem("generalInfo");
    sessionStorage.removeItem("houseHoldInfo");
    sessionStorage.removeItem("financialInfo");
    sessionStorage.removeItem("documents");
    sessionStorage.removeItem("feedback");
    // sessionStorage.removeItem('memberCounter');
    sessionStorage.removeItem("round");
    sessionStorage.removeItem("languageCode");
    sessionStorage.removeItem("paramsId");
    sessionStorage.removeItem("outreachRequestId");
    sessionStorage.removeItem("src");
  };

  render() {
    let selectedLang = "en";
    if (
      this.state.languageCode !== undefined &&
      this.state.languageCode !== ""
    ) {
      selectedLang = this.state.languageCode;
    }

    let { round } = this.state;

    return (
      <Router>
        {this.state.loading && <div className="mask-loading">{this.state.innerLoader && <div className="inner-loader"><Loader /> </div>}</div>}
        <div
          className={`msg-loadingFail${this.state.loadingFail ? " visible" : ""
            }`}
        >
          <span style={{ whiteSpace: "pre-line" }}>
            {this.state.languages[this.state.languageCode || "en"].errorMsg ||
              null}
          </span>
        </div>
        <div
          className={`msg-loginFail${this.state.loginFail ? " visible" : ""}`}
        >
          <span style={{ whiteSpace: "pre-line" }}>
            {this.state.languages[this.state.languageCode || "en"]
              .loginFailMsg || "Error: Access Denied"}
          </span>
        </div>
        <Switch>
          <Route
            exact
            path="/"
            render={(routeProps) => (
              <LoginCode
                logoUrl={logoUrl}
                setPersonalData={this.setPersonalData}
                data={this.state}
                landData={this.state.altLanguages.langs[selectedLang].loginPage}
                landData2={
                  this.state.languages[selectedLang].InformationReviewPage
                }
                altLang={this.state.altLanguages}
                setAccessCode={this.setAccessCode}
                getUserRawData={this.getUserRawData}
                endSession={this.endSession}
                setUserNames={this.setUserNames}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                setToState={this.setToState}
                codePlaceholder={
                  this.state.languages[selectedLang].loginPage.codePlaceholder
                }
                formTitle={
                  this.state.languages[selectedLang].loginPage.formTitle
                }
                formTitleCode={
                  this.state.languages[selectedLang].loginPage.formTitleCode
                }
                mm={this.state.languages[selectedLang].mm}
                dd={this.state.languages[selectedLang].dd}
                yy={this.state.languages[selectedLang].yy}
                months={this.state.languages[selectedLang].months}
                currLang={selectedLang}
                outreachRequestId={this.state.outreachRequestId}
                src={this.state.src}
                {...routeProps}
              />
            )}
          />

          <Route
            path="/welcome/:id?/:dob?"
            render={(routeProps) => (
              <Welcome
                logoUrl={logoUrl}
                data={this.state}
                landData={this.state.languages[selectedLang].Welcome}
                altLang={this.state.altLanguages}
                loginFail={this.loginFail}
                startLoading={this.startLoading}
                loginSuccess={this.loginSuccess}
                setToState={this.setToState}
                setLangCode={this.setLangCode}
                {...routeProps}
              />
            )}
          />

          <Route
            exact
            path="/screen/:id/:outreachRequestId?/:src?"
            render={(routeProps) => (
              <BirthdateVerification
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].BirthdatePage}
                altLang={this.state.altLanguages}
                handleChangeDate={this.handleChangeDate}
                data={this.state}
                setToState={this.setToState}
                setLangCode={this.setLangCode}
                setOutreachRequestId={this.setOutreachRequestId}
                setSrc={this.setSrc}
                languageCode={selectedLang}
                loginFail={this.loginFail}
                startLoading={this.startLoading}
                loginSuccess={this.loginSuccess}
                mm={this.state.languages[selectedLang].mm}
                dd={this.state.languages[selectedLang].dd}
                yy={this.state.languages[selectedLang].yy}
                newCodeMsg={this.state.languages[selectedLang].newCodeMsg}
                months={this.state.languages[selectedLang].months}
                outreachRequestId={this.state.outreachRequestId}
                src={this.state.src}
                {...routeProps}
              />
            )}
          />

          <Route
            path="/birthdate-verification"
            render={(routeProps) => (
              <BirthdateVerification
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].BirthdatePage}
                altLang={this.state.altLanguages}
                handleChangeDate={this.handleChangeDate}
                data={this.state}
                setToState={this.setToState}
                setOutreachRequestId={this.setOutreachRequestId}
                setSrc={this.setSrc}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                accessCode={this.state.accessCode}
                loginFail={this.loginFail}
                startLoading={this.startLoading}
                loginSuccess={this.loginSuccess}
                mm={this.state.languages[selectedLang].mm}
                dd={this.state.languages[selectedLang].dd}
                yy={this.state.languages[selectedLang].yy}
                newCodeMsg={this.state.languages[selectedLang].newCodeMsg}
                months={this.state.languages[selectedLang].months}
                outreachRequestId={this.state.outreachRequestId}
                src={this.state.src}
                {...routeProps}
              />
            )}
          />

          <Route
            path="/information-review"
            render={(routeProps) => (
              <InformationReview
                logoUrl={logoUrl}
                landData={
                  this.state.languages[selectedLang].InformationReviewPage
                }
                altLang={this.state.altLanguages}
                data={this.state}
                handleChange={this.handleChange}
                handleChangeDate={this.handleChangeDate}
                handleChangeGender={this.handleChangeGender}
                handleChangeAddress={this.handleChangeAddress}
                sendToApi={this.sendToApi}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
                mm={this.state.languages[selectedLang].mm}
                dd={this.state.languages[selectedLang].dd}
                yy={this.state.languages[selectedLang].yy}
                months={this.state.languages[selectedLang].months}
                {...routeProps}
              />
            )}
          />

          <Route
            path="/signature"
            render={(routeProps) => (
              <Signature
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].Documents.Step1}
                altLang={this.state.altLanguages}
                stateData={this.state.documents}
                globalStateData={this.state}
                saveSignature={this.saveSignature}
                clearignature={this.clearignature}
                sendToApi={this.sendToApi}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
                {...routeProps}
              />
            )}
          />

          <Route
            path="/general-info/step1"
            render={(routeProps) => (
              <MainWrapperGI
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].GeneralInfo.Step1}
                altLang={this.state.altLanguages}
                stateData={this.state.generalInfo}
                handleCheckboxClick={this.handleCheckboxClick}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  stateElement: "healthInsurance",
                  prevLink: "/signature",
                  nextLink: "/general-info/step2",
                  completed: 0,
                  stepCounter: "01",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/general-info/step2"
            render={(routeProps) => (
              <MainWrapperGI
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].GeneralInfo.Step2}
                altLang={this.state.altLanguages}
                stateData={this.state.generalInfo}
                personData={this.state.personData}
                handleCheckboxClick={this.handleCheckboxClick}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  stateElement: "usCitizen",
                  prevLink: "/general-info/step1",
                  nextLink: "/general-info/step3",
                  completed: 14.2,
                  stepCounter: "02",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/general-info/step3"
            render={(routeProps) => (
              <MainWrapperGI
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].GeneralInfo.Step3}
                altLang={this.state.altLanguages}
                stateData={this.state.generalInfo}
                personData={this.state.personData}
                handleCheckboxClick={this.handleCheckboxClick}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "gender",
                  stateElement: "gender",
                  prevLink: "/general-info/step2",
                  nextLink: "/general-info/step4",
                  completed: 28.4,
                  stepCounter: "03",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/general-info/step4"
            render={(routeProps) => (
              <MainWrapperGI
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].GeneralInfo.Step4}
                altLang={this.state.altLanguages}
                personData={this.state.personData}
                stateData={this.state.generalInfo}
                handleCheckboxClick={this.handleCheckboxClick}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  stateElement: "pregnant",
                  prevLink: "/general-info/step3",
                  nextLink: "/general-info/step5",
                  completed: 42.6,
                  stepCounter: "04",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/general-info/step5"
            render={(routeProps) => (
              <MainWrapperGI
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].GeneralInfo.Step5}
                altLang={this.state.altLanguages}
                stateData={this.state.generalInfo}
                personData={this.state.personData}
                handleCheckboxClick={this.handleCheckboxClick}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  stateElement: "blind",
                  prevLink: "/general-info/step4",
                  nextLink: "/general-info/step6",
                  completed: 56.8,
                  stepCounter: "05",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/general-info/step6"
            render={(routeProps) => (
              <MainWrapperGI
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].GeneralInfo.Step6}
                altLang={this.state.altLanguages}
                stateData={this.state.generalInfo}
                handleFamilyMemberChange={this.handleFamilyMemberChange}
                decreaseFamilyMember={this.decreaseFamilyMember}
                increaseFamilyMember={this.increaseFamilyMember}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "familyMembers",
                  stateElement: "familyMembers",
                  prevLink: "/general-info/step5",
                  nextLink: "/general-info/step7",
                  completed: 71,
                  stepCounter: "06",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/general-info/step7"
            render={(routeProps) => (
              <MainWrapperGI
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].GeneralInfo.Step7}
                altLang={this.state.altLanguages}
                stateData={this.state.generalInfo}
                handleChangeSilder={this.handleChangeSilder}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "houseHoldTotalIncome",
                  stateElement: "houseHoldTotalIncome",
                  prevLink: "/general-info/step6",
                  nextLink: "/general-info/step8",
                  completed: 85.2,
                  stepCounter: "07",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/general-info/step8"
            render={(routeProps) => (
              <MainWrapperGI
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].GeneralInfo.Step8}
                altLang={this.state.altLanguages}
                stateData={this.state.generalInfo}
                personData={this.state.personData}
                handleChangeSilder={this.handleChangeSilder}
                sendToApi={this.sendToApi}
                logoUrl={logoUrl}
                {...routeProps}
                stepData={{
                  view: "milestone",
                  milestone: "1",
                  stateElement: "milestone",
                  prevLink: "/general-info/step7",
                  nextLink: "/financial-info/step1",
                  completed: 100,
                  stepCounter: "08",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/financial-info/step1"
            render={(routeProps) => (
              <MainWrapperFi
                logoUrl={logoUrl}
                landData={
                  this.state.languages[selectedLang].FinancialInfo.Step1
                }
                altLang={this.state.altLanguages}
                stateData={this.state.financialInfo}
                handleCheckboxDropdown={this.handleCheckboxDropdown}
                generateEmptyEmployerObj={this.generateEmptyEmployerObj}
                addRow={this.addRow}
                handleName={this.handleName}
                handleAmount={this.handleAmount}
                removeRow={this.removeRow}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "employed",
                  stateElement: "employed",
                  stateObjName: "employersList",
                  prevLink: "/general-info/step8",
                  nextLink: "/financial-info/step2",
                  completed: 0,
                  stepCounter: "01",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />
          <Route
            path="/financial-info/step2"
            render={(routeProps) => (
              <MainWrapperFi
                logoUrl={logoUrl}
                landData={
                  this.state.languages[selectedLang].FinancialInfo.Step2
                }
                altLang={this.state.altLanguages}
                stateData={this.state.financialInfo}
                addRow={this.addRow}
                handleName={this.handleName}
                handleAmount={this.handleAmount}
                removeRow={this.removeRow}
                handleIncomeChange={this.handleIncomeChange}
                handleRowClick={this.handleRowClick}
                handleCheckboxDropdown={this.handleCheckboxDropdown}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "income",
                  stateElement: "income",
                  stateList: "incomeList",
                  stateObjName: "incomeListOthers",
                  prevLink: "/financial-info/step1",
                  nextLink: "/financial-info/step3",
                  completed: 25,
                  stepCounter: "02",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/financial-info/step3"
            render={(routeProps) => (
              <MainWrapperFi
                logoUrl={logoUrl}
                landData={
                  this.state.languages[selectedLang].FinancialInfo.Step3
                }
                altLang={this.state.altLanguages}
                stateData={this.state.financialInfo}
                addRow={this.addRow}
                handleName={this.handleName}
                handleAmount={this.handleAmount}
                removeRow={this.removeRow}
                handleIncomeChange={this.handleIncomeChange}
                handleRowClick={this.handleRowClick}
                handleCheckboxDropdown={this.handleCheckboxDropdown}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "expenses",
                  stateElement: "expenses",
                  stateList: "expenseList",
                  stateObjName: "expenseListOthers",
                  prevLink: "/financial-info/step2",
                  nextLink: "/financial-info/step4",
                  completed: 50,
                  stepCounter: "03",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/financial-info/step4"
            render={(routeProps) => (
              <MainWrapperFi
                logoUrl={logoUrl}
                landData={
                  this.state.languages[selectedLang].FinancialInfo.Step4
                }
                altLang={this.state.altLanguages}
                stateData={this.state.financialInfo}
                addRow={this.addRow}
                handleName={this.handleName}
                handleAmount={this.handleAmount}
                removeRow={this.removeRow}
                handleIncomeChange={this.handleIncomeChange}
                handleRowClick={this.handleRowClick}
                handleCheckboxDropdown={this.handleCheckboxDropdown}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "assets",
                  stateElement: "assets",
                  stateList: "assetsList",
                  stateObjName: "assetsListOthers",
                  prevLink: "/financial-info/step3",
                  nextLink: "/financial-info/step5",
                  completed: 75,
                  stepCounter: "04",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />
          <Route
            path="/financial-info/step5"
            render={(routeProps) => (
              <MainWrapperFi
                logoUrl={logoUrl}
                landData={
                  this.state.languages[selectedLang].FinancialInfo.Step5
                }
                altLang={this.state.altLanguages}
                stateData={this.state.financialInfo}
                globalStateData={this.state}
                personData={this.state.personData}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "milestone",
                  milestone: "2",
                  checkFormembers: true,
                  stateElement: "milestone",
                  prevLink: "/financial-info/step4",
                  nextLink: "/houseHold/step1",
                  completed: 100,
                  stepCounter: "05",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />
          <Route
            path="/household/step1"
            render={(routeProps) => (
              <MainWrapperHousehold
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].HouseHold.Step1}
                altLang={this.state.altLanguages}
                stateData={this.state.houseHoldInfo}
                globalStateData={this.state}
                handleMemberInfoDate={this.handleMemberInfoDate}
                handleMemberInfo={this.handleMemberInfo}
                setRound={this.setRound}
                setInitalFamilyMember={this.setInitalFamilyMember}
                sendToApi={this.sendToApi}
                months={this.state.languages[selectedLang].months}
                mm={this.state.languages[selectedLang].mm}
                dd={this.state.languages[selectedLang].dd}
                yy={this.state.languages[selectedLang].yy}
                {...routeProps}
                stepData={{
                  stateElement: "generalData",
                  view: "memberData",
                  editPrevious: true,
                  checkIsChild: true,
                  round: round,
                  prevLink: "/financial-info/step5",
                  nextLink: "/household/step2",
                  completed: 0,
                  stepCounter: "01",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />
          <Route
            path="/household/step2"
            render={(routeProps) => (
              <MainWrapperHousehold
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].HouseHold.Step2}
                altLang={this.state.altLanguages}
                stateData={this.state.houseHoldInfo}
                handleCheckboxDropdownHousehold={
                  this.handleCheckboxDropdownHousehold
                }
                addRowHousehold={this.addRowHousehold}
                handleNameHousehold={this.handleNameHousehold}
                handleAmountHousehold={this.handleAmountHousehold}
                removeRowHousehold={this.removeRowHousehold}
                sendToApi={this.sendToApi}
                generateEmptyEmployerObjHouseHold={
                  this.generateEmptyEmployerObjHouseHold
                }
                {...routeProps}
                stepData={{
                  view: "employed",
                  stateElement: "employed",
                  stateObjName: "employersList",
                  round: round,
                  prevLink: "/household/step1",
                  nextLink: "/household/step3",
                  completed: 25,
                  stepCounter: "02",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />
          <Route
            path="/household/step3"
            render={(routeProps) => (
              <MainWrapperHousehold
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].HouseHold.Step3}
                altLang={this.state.altLanguages}
                stateData={this.state.houseHoldInfo}
                handleIncomeChangeHousehold={this.handleIncomeChangeHousehold}
                handleCheckboxDropdownHousehold={
                  this.handleCheckboxDropdownHousehold
                }
                addRowHousehold={this.addRowHousehold}
                handleNameHousehold={this.handleNameHousehold}
                handleAmountHousehold={this.handleAmountHousehold}
                removeRowHousehold={this.removeRowHousehold}
                handleRowClickHousehold={this.handleRowClickHousehold}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "income",
                  stateElement: "income",
                  stateList: "incomeList",
                  stateObjName: "incomeListOthers",
                  round: round,
                  prevLink: "/household/step2",
                  nextLink: "/household/step4",
                  completed: 50,
                  stepCounter: "03",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />
          <Route
            path="/household/step4"
            render={(routeProps) => (
              <MainWrapperHousehold
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].HouseHold.Step4}
                altLang={this.state.altLanguages}
                stateData={this.state.houseHoldInfo}
                globalStateData={this.state}
                setRound={this.setRound}
                handleIncomeChangeHousehold={this.handleIncomeChangeHousehold}
                handleCheckboxDropdownHousehold={
                  this.handleCheckboxDropdownHousehold
                }
                addRowHousehold={this.addRowHousehold}
                handleNameHousehold={this.handleNameHousehold}
                handleAmountHousehold={this.handleAmountHousehold}
                removeRowHousehold={this.removeRowHousehold}
                handleRowClickHousehold={this.handleRowClickHousehold}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "expenses",
                  stateElement: "expenses",
                  stateList: "expenseList",
                  stateObjName: "expenseListOthers",
                  round: round,
                  prevLink: "/household/step3",
                  nextLink: "/household/step5",
                  completed: 75,
                  stepCounter: "04",
                  checkFormembers: true,
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />
          <Route
            path="/household/step5"
            render={(routeProps) => (
              <MainWrapperHousehold
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].HouseHold.Step5}
                altLang={this.state.altLanguages}
                stateData={this.state.houseHoldInfo}
                sendToApi={this.sendToApi}
                globalStateData={this.state}
                setRound={this.setRound}
                {...routeProps}
                stepData={{
                  view: "milestone",
                  milestone: "3",
                  stateElement: "milestone",
                  round: round,
                  checkIsChild: true,
                  prevLink: "/household/step4",
                  nextLink: "/documents/step1",
                  completed: 100,
                  stepCounter: "05",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />
          {/* <Route path="/documents/step1" render={(routeProps) => <MainWrapperDocuments
                    landData={this.state.languages[selectedLang].Documents.Step1}   
                    stateData={this.state.documents}   
                    globalStateData={this.state}  
                    saveSignature = {this.saveSignature}
                    clearignature = {this.clearignature}
                    sendToApi = {this.sendToApi}
                    {...routeProps}
                    stepData ={{  
                        view:'signature',  
                        stateElement:'signature',   
                        editPrevious:true, 
                        prevLink:'/household/step5', 
                        nextLink: '/documents/step2',
                        completed:0,
                        stepCounter:'01',
                    }}
                    /> } /> */}
          <Route
            path="/documents/step1"
            render={(routeProps) => (
              <MainWrapperDocuments
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].Documents.Step2}
                altLang={this.state.altLanguages}
                stateData={this.state.documents}
                handlePhotoSend={this.handlePhotoSend}
                globalStateData={this.state}
                removePhoto={this.removePhoto}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "photos",
                  stateElement: "photos",
                  editPrevious: true,
                  prevLink: "/household/step5",
                  nextLink: "/documents/step2",
                  completed: 0,
                  stepCounter: "01",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
                confirmNewDocuments={this.state.confirmNewDocuments}
                showConfirmNewDocuments={this.showConfirmNewDocuments}
                closeConfirmNewDocuments={this.closeConfirmNewDocuments}
              />
            )}
          />
          <Route
            path="/documents/step2"
            render={(routeProps) => (
              <MainWrapperDocuments
                logoUrl={logoUrl}
                landData={
                  this.state.altLanguages.langs[selectedLang].Documents.Step3
                }
                altLang={this.state.altLanguages}
                stateData={this.state.documents}
                handleChangeContacts={this.handleChangeContacts}
                handleRowClickContacts={this.handleRowClickContacts}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "contacts",
                  stateElement: "contacts",
                  prevLink: "/documents/step2",
                  nextLink: "/feedback",
                  completed: 100,
                  stepCounter: "02",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />
          <Route
            path="/feedback"
            render={(routeProps) => (
              <Feedback
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].Feedback}
                altLang={this.state.altLanguages}
                stateData={this.state.feedback}
                handleRaiting={this.handleRaiting}
                handleFeedback={this.handleFeedback}
                sendToApi={this.sendToApi}
                {...routeProps}
                stepData={{
                  view: "feedback",
                  stateElement: "feedback",
                  prevLink: "/documents/step3",
                  nextLink: "/thankyou",
                }}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />

          <Route
            path="/logout"
            render={(routeProps) => (
              <Logout
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].Logout}
                altLang={this.state.altLanguages}
                endSession={this.endSession}
                sendToApi={this.sendToApi}
                {...routeProps}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
                loading={this.state.loading}
              />
            )}
          />
          <Route
            path="/thankyou"
            render={(routeProps) => (
              <Thankyou
                logoUrl={logoUrl}
                landData={this.state.altLanguages.langs[selectedLang].Thankyou}
                altLang={this.state.altLanguages}
                endSession={this.endSession}
                sendToApi={this.sendToApi}
                {...routeProps}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
              />
            )}
          />

          <Route
            render={(routeProps) => (
              <NotFound
                logoUrl={logoUrl}
                landData={this.state.languages[selectedLang].NotFound}
                altLang={this.state.altLanguages}
                {...routeProps}
                setLangCode={this.setLangCode}
                languageCode={selectedLang}
              />
            )}
          />
        </Switch>
      </Router>
    );
  }
}

export default App;
